// NPM Imports
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Components Imports

// Actions Imports
import { updateDraggedSection } from "../../../actions/DocumentActions/index";

// Services Imports

// Internal Imports
import getDragImage from "../../../utils/dragUtils";

// Destructuring

export default function ComponentDragBtn({
  draggedSection,
  section,
  isLocked,
  itemType,
  rowIndex,
  colIndex,
  isComponentActive,
}) {
  // Local State
  const [dragImgEle, setDragImgEle] = useState(null);

  // mapDispatchToProps
  const dispatch = useDispatch();

  useEffect(() => {
    if (isComponentActive) {
      const dragImg = getDragImage(section.type);
      if (dragImg) {
        const img = new Image();
        img.src = dragImg;
        setDragImgEle(img);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComponentActive]);

  if (isLocked) return null;

  // setTimout is used to fix a chrome bug
  // which causes the dragEnd to call immediately
  const _onDragStart = event => {
    if (dragImgEle) {
      event.dataTransfer.setDragImage(dragImgEle, 30, 40);
    }
    event.dataTransfer.effectAllowed = "all";
    const targetEle = event.target;
    setTimeout(() => {
      if (targetEle.parentElement) {
        targetEle.parentElement.style.visibility = "hidden";
      }
      dispatch(updateDraggedSection(section, itemType, rowIndex, colIndex));
    }, 0);
  };

  const _onDragEnd = event => {
    if (event && event.target.parentElement) {
      event.target.parentElement.style.visibility = "visible";
    }
    updateDraggedSection(null, null, null, null);
  };

  const _handleDragClick = event => {
    if (!event) {
      event = window.event;
    }

    // IE9 & Other Browsers
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    // IE8 and Lower
    else {
      event.cancelBubble = true;
    }
  };

  const isDragged = draggedSection && section.id === draggedSection.id;

  return (
    <div
      className={`drag-button-container ${
        isDragged ? "dragged-component-button" : ""
      }   ${section.type === "Table" ? "table-drag-btn-container" : ""}`}
      data-test="document-item-drag-button-container">
      <div
        className="drag-button-action component-action"
        data-test="document-item-drag-button-action">
        <Tooltip
          placement="top"
          overlay="Click and drag to reposition"
          align={{ offset: [0, 3] }}>
          <span
            draggable
            onDragStart={_onDragStart}
            onDragEnd={_onDragEnd}
            onMouseDown={_handleDragClick}
            data-test="documentitems-drag-the-content-btn"
            className="btn-icon"
            id="drag-the-content-btn"
            style={{ pointerEvents: "auto" }}
            role="button"
            tabIndex={0}>
            <FontAwesomeIcon icon={["far", "arrows-alt"]} />
          </span>
        </Tooltip>
      </div>
    </div>
  );
}
